import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import Start from '../components/pages/Start';
import Menus from '../components/pages/Menus';
import Meals from '../components/pages/Meals';
import Product from '../components/pages/Product';
import Stores from '../components/pages/Stores';
import Checkout from '../components/pages/Checkout';
import Confirmation from '../components/pages/Confirmation';
import Stammis from '../components/pages/Stammis';
import Setup from '../components/pages/Setup';
import DeliveryOptions from '../components/pages/DeliveryOptions';

function RoutesData () {
  return (
    <Routes>
      <Route path="/butik/:storeId" element={<Start />} />
      <Route
        path="/butik/:storeId/restaurant/:restaurantId/meny/:menuId/produkt/:productId"
        element={<Product />}
      />
      <Route
        path="/butik/:storeId/restaurant/:restaurantId"
        element={<Meals />}
      />
      <Route path="/butik/:storeId/restaurant" element={<Menus />} />
      <Route path="/butik/:storeId/betala/:orderId" element={<Checkout />} />
      <Route path="/butik/:storeId/stammis" element={<Stammis />} />
      <Route path="/butik/:storeId/leverans" element={<DeliveryOptions />} />
      <Route path="/butik/:storeId/:orderId/tack" element={<Confirmation />} />
      <Route path="/start/:bms" element={<Setup />} />
      <Route path="/" element={<Stores />} />
    </Routes>
  );
}

export default RoutesData;
